export default __webpack_public_path__ + "static/media/TAG-logo.ebb82c47.png";